import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { Progress } from './components/Progress';
import { OperationData } from './components/OperationData';
import { StrikeOptions } from './components/StrikeOptions';
import { Barriers } from './components/Barriers';
import { OperationResult } from './components/OperationResult';
import { Header } from './components/Header';
import { TooltipModal } from '@/modules/common/components/TooltipModal';

import { CustomOperation } from '@/modules/trade/services/custom-operations';
import { tooltipsData } from './data';
import { TooltipTypes } from './types';

interface Props {
  customOperationData: CustomOperation;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomOperationDetailsContent',
  props: {
    customOperationData: null
  },
  setup(__props: any) {

const { customOperationData } = __props as {
  customOperationData: CustomOperation;
}



const isTooltipModalOpen = ref(false);
const tooltipData = ref({ title: '', description: '' });

const hasStrikeOptions = computed(() => {
  return (
    customOperationData?.strikeOptions &&
    customOperationData?.strikeOptions?.length > 0
  );
});

const hasMonitoringBarriers = computed(() => {
  return (
    customOperationData?.monitoring &&
    customOperationData?.monitoring?.length > 0
  );
});

const handleOpenTooltipModal = (type: TooltipTypes) => {
  tooltipData.value = tooltipsData[type];
  isTooltipModalOpen.value = true;
};

const handleCloseTooltipModal = () => {
  isTooltipModalOpen.value = false;
};

return { __sfc: true,isTooltipModalOpen, tooltipData, hasStrikeOptions, hasMonitoringBarriers, handleOpenTooltipModal, handleCloseTooltipModal, Progress, OperationData, StrikeOptions, Barriers, OperationResult, Header, TooltipModal }
}

})